import { render, staticRenderFns } from "./main-lawyer.vue?vue&type=template&id=ef843c24&scoped=true&"
import script from "./main-lawyer.vue?vue&type=script&lang=js&"
export * from "./main-lawyer.vue?vue&type=script&lang=js&"
import style0 from "./main-lawyer.vue?vue&type=style&index=0&id=ef843c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef843c24",
  null
  
)

export default component.exports